import React from 'react'

import { Field } from 'redux-form'

import { Grid, useMediaQuery } from '@material-ui/core'

import NumberField from '~/components/fields/NumberField'
import SelectField from '~/components/fields/SelectField'
import ExtendedButton from '~/components/shared/ExtendedButton'

import { loanTermOptions, paymentFreqOptions } from '~/data/options'

import { useFinanceSectionStyles } from './productCalculateFormTemplate.styles'

interface ProductCalculateFormTemplateProps {
  loading: boolean
  submitting: boolean
}

const ProductCalculateFormTemplate: React.FC<ProductCalculateFormTemplateProps> = ({
  loading,
  submitting
}) => {
  const s = useFinanceSectionStyles()
  const isMobile = useMediaQuery('(max-width: 600px)')

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Field
            id="loan_amount"
            name="loan_amount"
            label="Loan Amount"
            placeholder="Loan Amount"
            component={NumberField}
            fullWidth
            InputLabelProps={{ shrink: undefined }}
            required
            helperText="Loan amount should be less than one billion"
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            id="interest_rate"
            name="interest_rate"
            label="Interest Rate"
            placeholder="Interest Rate"
            component={NumberField}
            fullWidth
            InputLabelProps={{ shrink: undefined }}
            required
            helperText="Interest rate should be more than 0 and less than 999"
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            id="loan_term"
            name="loan_term"
            label="Loan Term"
            placeholder="Loan Term"
            component={SelectField}
            options={loanTermOptions}
            fullWidth
            required
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            id="payment_freq"
            name="payment_freq"
            label="Payment Freq"
            placeholder="Payment Freq"
            options={paymentFreqOptions}
            component={SelectField}
            fullWidth
            required
            disabled={loading}
          />
        </Grid>
      </Grid>

      <ExtendedButton
        size="large"
        mx="auto"
        mt={2}
        type="submit"
        loading={submitting}
        fullWidth={isMobile}
        className={s.calculateBtn}
        disabled={loading}
      >
        Calculate
      </ExtendedButton>
    </>
  )
}

export default ProductCalculateFormTemplate
